<div class="login-container">
  @if (showTitle && !loginSecondHolder) {
    <h2 class="h-main h-main-medium">
      {{ 'login_recover_request_in_progress' | translate }}
    </h2>
  } @else if (showTitle && loginSecondHolder) {
    <h2 class="h-main h-main-medium">
      {{ 'login_recover_request_in_progress_second_holder' | translate }}
    </h2>
  }

  <!-- <h2 class="h-main h-main-medium" *ngIf="showTitle"> {{'login_recover_request_in_progress' | translate }} </h2> -->
  @if (!showOtp) {
    <form class="login" [formGroup]="loginForm">
      <div class="row">
        @if (isRegister) {
          <div class="col-sm-6 col-12">
            <div class="input-box">
              <label [class.has-error]="loginForm?.controls['phone']?.touched && !loginForm?.controls?.phone?.valid">
                {{ 'Teléfono' | translate }}
              </label>
              <input
                id="login-input-phone"
                class="form-control input-text"
                type="text"
                formControlName="phone"
                maxlength="9"
              />
              @if (loginForm.controls['phone'].touched && loginForm.controls['phone'].hasError('required')) {
                <p class="has-error">
                  {{ 'hipotecas_error_required' | translate }}
                </p>
              }

              @if (loginForm.controls['phone'].touched && loginForm.controls['phone'].hasError('pattern')) {
                <p class="has-error">
                  {{ 'hipotecas_error_invalid_format_phone' | translate }}
                </p>
              }
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="input-box">
              <label
                [class.has-error]="
                  loginForm?.controls['idNumberTit']?.touched && !loginForm?.controls?.idNumberTit?.valid
                "
              >
                {{ 'login_nie' | translate }}
              </label>
              <input
                id="login-input-idNumberTit"
                class="form-control input-text"
                type="text"
                formControlName="idNumberTit"
                maxlength="9"
              />

              @if (
                loginForm.controls['idNumberTit'].touched && loginForm.controls['idNumberTit'].hasError('required')
              ) {
                <p class="has-error">
                  {{ 'hipotecas_error_required' | translate }}
                </p>
              }

              @if (
                loginForm?.controls['idNumberTit']?.touched &&
                loginForm?.controls['idNumberTit']?.hasError('validateDocument')
              ) {
                <p class="has-error">
                  {{ 'hipotecas_error_validate_dni' | translate }}
                </p>
              }
            </div>
          </div>
        }
        <div [ngClass]="{ 'col-sm-6 col-12': isRegister, 'col-12': !isRegister }">
          <div class="input-box">
            <label [class.has-error]="loginForm?.controls['email']?.touched && !loginForm?.controls?.email?.valid">
              {{ 'login_email' | translate }}
            </label>
            <input
              id="login-input-email"
              class="form-control input-text"
              type="text"
              formControlName="email"
              (focus)="restoreValidation()"
              maxlength="80"
            />

            @if (loginForm.controls['email'].touched && loginForm.controls['email'].hasError('required')) {
              <p class="has-error">
                {{ 'hipotecas_error_required' | translate }}
              </p>
            }

            @if (loginForm.controls['email'].touched && loginForm.controls['email'].hasError('pattern')) {
              <p class="has-error">
                {{ 'hipotecas_error_email_format' | translate }}
              </p>
            }
          </div>
        </div>

        @if (isRegister) {
          <div class="col-sm-6 col-12">
            <div class="input-box">
              <label [class.has-error]="loginForm?.controls['email']?.touched && !loginForm?.controls?.email?.valid">
                {{ 'Repetir email' | translate }}
              </label>
              <input
                id="login-input-repeatEmail"
                class="form-control input-text"
                type="text"
                formControlName="repeatEmail"
                onpaste="return false;"
                autocomplete="off"
                (focus)="restoreValidation()"
                maxlength="80"
              />
              <!-- ondrop="return false;"
                            ondragover="return false;" -->

              @if (
                loginForm.controls['repeatEmail'].touched && loginForm.controls['repeatEmail'].hasError('required')
              ) {
                <p class="has-error">
                  {{ 'hipotecas_error_required' | translate }}
                </p>
              }

              @if (loginForm.controls['repeatEmail'].touched && loginForm.controls['repeatEmail'].hasError('pattern')) {
                <p class="has-error">
                  {{ 'hipotecas_error_email_format' | translate }}
                </p>
              }

              @if (loginForm.controls['repeatEmail'].touched && loginForm?.errors?.invalidRepearEmail) {
                <p class="has-error">
                  {{ 'error_repeat_email' | translate }}
                </p>
              }
            </div>
          </div>
        }

        <div class="col-12">
          @if (isLoginFailed) {
            <div class="text-center">
              @if (!messageError) {
                <p class="has-error">
                  {{ 'login_error_generic' | translate }}
                </p>
              }
              <div class="has-error">
                <p [innerHTML]="messageError | translate"></p>
              </div>
            </div>
          }
        </div>

        @if (isRegister) {
          <div class="col-12">
            <div class="checkbox">
              <input type="checkbox" id="login-input-politica-privacidad" formControlName="protection_clauses_1" />
              <label
                id="login-label-politica-privacidad"
                [class.has-error]="
                  loginForm?.controls['protection_clauses_1']?.touched &&
                  !loginForm?.controls['protection_clauses_1']?.valid
                "
                for="login-input-politica-privacidad"
              >
                <span [innerHTML]="'hipotecas_protection_clauses_privacy_policy' | translate"></span>
              </label>

              @if (
                loginForm.controls['protection_clauses_1'].touched && !loginForm.controls['protection_clauses_1'].valid
              ) {
                <p class="has-error">
                  {{ 'hipotecas_error_politica_privadidad' | translate }}
                </p>
              }
            </div>

            <div class="row">
              <div class="col-12">
                <div class="checkbox">
                  <input
                    type="checkbox"
                    id="login-input-informacion-precontractual"
                    formControlName="protection_clauses_2"
                  />
                  <label
                    id="login-label-informacion-precontractual"
                    [class.has-error]="
                      loginForm?.controls['protection_clauses_2']?.touched &&
                      !loginForm?.controls['protection_clauses_2']?.valid
                    "
                    for="login-input-informacion-precontractual"
                  >
                    <span [innerHTML]="'hipotecas_protection_clauses_pre_contractual_information' | translate"></span>
                    <span
                      class="tooltip-inline"
                      id="login-content-tooltip-protection-clauses-2"
                      (click)="openToast('login-tooltip-protection-clauses-2')"
                    >
                      <a
                        id="login-tooltip-protection-clauses-2"
                        class="icon-a"
                        href="javascript:void(0)"
                        tooltipEvent="focus"
                        [pTooltip]="'login_tooltip_hipotecas_protection_clauses_web_2' | translate"
                      >
                        <img class="ico-info" src="assets/img/info.svg"
                      /></a>
                    </span>
                  </label>

                  @if (
                    loginForm.controls['protection_clauses_2'].touched &&
                    !loginForm.controls['protection_clauses_2'].valid
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_informacion_precontractual' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        <div class="col-12 captcha">
          @if (isRegister) {
            <div
              re-captcha
              (success)="loginForm.controls['captcha'].setValue($event)"
              (error)="loginForm.controls['captcha'].setValue('')"
            ></div>
          }

          @if (loginForm?.controls['captcha']?.touched && !loginForm?.controls['captcha']?.valid) {
            <p class="has-error text-center no-pd">
              {{ 'hipotecas_error_captcha' | translate }}
            </p>
          }
          <button class="btn btn-02" (click)="generateOTP()" id="login-btn-cont-form">
            {{ 'login_btn_continue' | translate }}
          </button>
        </div>
      </div>
    </form>
  } @else {
    <form [formGroup]="otpForm">
      <p
        class="text-center modal-p"
        [innerHTML]="'login_email_msg_info' | translate: { email: loginForm?.controls['email']?.value }"
      >
        <!-- Para poder continuar debes introducir el código que te acabamos de enviar a tu email: {{loginForm?.controls['email']?.value}}  -->
      </p>
      <div class="row">
        <div class="col-12">
          <label [class.has-error]="otpForm?.controls['code']?.touched && !otpForm?.controls['code']?.valid">
            {{ 'login_code' | translate }}
            <span id="login-content-tooltip-code-otp" (click)="openToast('login-tooltip-code-otp')">
              <a
                id="login-tooltip-code-otp"
                class="icon-a"
                href="javascript:void(0)"
                tooltipEvent="focus"
                [pTooltip]="'login_tooltip_code' | translate"
              >
                <img class="ico-info" src="assets/img/info.svg" />
              </a>
            </span>
          </label>
          <input id="login-code-otp" class="form-control input-text" type="text" formControlName="code" maxlength="4" />

          @if (otpForm.controls['code']?.touched && otpForm.controls['code']?.hasError('required')) {
            <p class="has-error text-center">
              {{ 'hipotecas_error_required' | translate }}
            </p>
          }

          @if (otpError) {
            <div class="text-center center-block">
              @if (!messageError) {
                <p class="has-error">
                  {{ 'login_error_generic' | translate }}
                </p>
              } @else {
                <p class="has-error" [innerHTML]="messageError | translate"></p>
              }
            </div>
          }
        </div>
      </div>
      <button class="btn btn-02 btn-modal" type="submit" (click)="confirmationOTP()" id="login-btn-otp">
        {{ 'login_btn_continue' | translate }}
      </button>
    </form>
  }
</div>
